import { CircularProgress, EmptyState, Grid, Stack } from '@all-manager/design-system-v2';
import useGetProviderContracts from "../../api/useGetProviderContracts";
import NoContractsIcon from "../../assets/no-contracts.svg?react";
import ContractCard from "./ContractCard/ContractCard";

type Props = {
  providerId: string;
}

export default function ContractList(props: Props) {
  const { data: contracts, isLoading } = useGetProviderContracts(props.providerId);

  if (isLoading) {
    return (
      <Stack alignItems="center">
        <CircularProgress aria-label="Chargement des contrats" />
      </Stack>
    );
  }

  if (!contracts || contracts.length === 0) {
    return (
      <EmptyState
        title="Aucun contrat"
        subtitle="Retrouvez ici tous les contrats associés à ce prestataire."
        image={<NoContractsIcon />}
      />
    );
  }

  return (
    <Grid container spacing={2}>
      {contracts.map((contract) => (
        <Grid key={contract.id} size={{ xs: 12, lg: 6 }}>
          <ContractCard contract={contract} />
        </Grid>
      ))}
    </Grid>
  );
}
